<template>
  <div class="sidebar">
    <el-menu
      :default-active="$route.path"
      router
      unique-opened
      class="el-menu-vertical-demo"
    >

      <template v-for="(item, index) in this.$store.state.nva" v-if="!item.hidden">

        <!--二级菜单-->
        <template v-if="!item.leaf">
          <el-submenu :index="index+''">
            <template slot="title">
              <i :class="item.meta.icon" />
              <span>{{ item.meta.title }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="(child, index) in item.children" :key="index+item" :index="child.path">
                {{ child.meta.title }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </template>
        <!--一级菜单-->
        <template v-else>
          <el-menu-item v-for="(child) in item.children" :key="child.meta.title" :index="child.path">
            <i :class="child.meta.icon" />
            <span slot="title">{{ child.meta.title }}</span>
          </el-menu-item>
        </template>
        <!-- <subMenu v-else :data="item" :key="key"></subMenu> -->

      </template>

    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    onRoutes() {
      // 当前激活菜单的 index
      return this.$route.path.replace('/', '')
    }
  },
  methods: {

  }
}
</script>
<style scoped>
 .iconfont{
   margin-right:10px
 }

</style>
